<template>
    <div v-show="thumbnailLoaded">
        <div class="card shadow-sm">
            <img :src="thumbnailUrl" class="bd-placeholder-img card-img-top" alt="Thumbnail">
            <div class="card-body">
                <p class="card-text">{{ video.title }}</p>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                        <button type="button" class="btn btn-sm btn-danger">
                            <a :href="'https://www.youtube.com/watch?v=' + video.id" class="text-white no-underline" target="_blank">▶ 再生</a>
                        </button>
                    </div>
                    <small class="text-body-secondary">{{ video.date }}</small>
                </div>
            </div>
            <div :style="{ backgroundColor: channelColors[video.channel] }" class="channel-band">
                <span class="channel-name">{{ video.channel }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoCard',
    props: {
        video: {
            type: Object,
            required: true
        }
    },
    computed: {
        thumbnailUrl() {
            return this.video.thumbnailUrl;
            // return "https://img.youtube.com/vi/" + this.video.id + "/hqdefault.jpg";
        }
    },
    data() {
        return {
            // これがfalseになると、このカードコンポーネント自体を非表示にする
            // サムネイルの読み込みがエラーしたらここをfalseにする
            // ようにしたかったが無理だった
            // エラー情報がYoutubeのセキュリティでJSではハンドリングできないようになっているっぽい
            thumbnailLoaded: true,
            channelColors: {
                okopure: '#D5006D',
                okawari: '#FFB3D9',
                fr2pon: '#B3E5FC',
                stmlt: '#9C27B0',
                badivy: '#BB0000',
                chippi: '#B2FF8C',
                sunnycircle: '#EE7700'
            }
        };
    },
};
</script>

<style scoped>
.no-underline {
    text-decoration: none;
}
.channel-band {
    padding: 1px; /* 帯の上下のパディング */
    color: white; /* 文字色を白に設定 */
    text-align: center; /* 中央揃え */
}
.channel-name {
    font-weight: bold; /* 太字に設定 */
}
.card {
  display: block;
}

</style>